module.exports = __webpack_public_path__ + "static/media/VILLANUEVA.7374c9a2.png";